import { BaseActivityEvent } from './BaseActivityEvent'
import { ReactComponent as Icon } from './icons/approval.svg'
import { Actor } from './Actor'
import { ActivityEventPosition, ArticleReviewRequestEvent } from './Types'
import { Link } from 'react-router-dom'
import { stopPropagation } from 'utils'

interface Props extends ActivityEventPosition {
  event: ArticleReviewRequestEvent
}

const ArticleReviewRequest = ({ event, ...props }: Props) => {
  const {
    user,
    article,
    data: { branch, base_branch, user_review, reviewer },
  } = event
  const isBaseBranch = base_branch.key === article.key

  const content = isBaseBranch ? (
    <>
      <Actor displayName={user.display_name || 'Anonymous User'} userId={user?.id} /> requested approval from{' '}
      <Actor displayName={reviewer.display_name || 'Anonymous User'} userId={reviewer?.id} /> on this linked copy:{' '}
      <Link to={branch.url} onClick={stopPropagation}>
        {branch.title}
      </Link>
    </>
  ) : (
    <>
      <Actor displayName={user.display_name || 'Anonymous User'} userId={user?.id} /> requested approval from{' '}
      <Actor displayName={reviewer.display_name || 'Anonymous User'} userId={reviewer?.id} /> on this linked copy
    </>
  )

  return (
    <BaseActivityEvent
      {...props}
      icon={<Icon />}
      timestamp={event.timestamp}
      content={content}
      message={user_review.message}
    />
  )
}

export { ArticleReviewRequest }
